export const ITEM_HEIGHT = 36;
/**
 * Minimum row height for the mobile drill-down tree — a floor, not a fixed height.
 * Long BIM names wrap freely and grow the row past it; nothing virtualises on this value.
 */
export const ITEM_HEIGHT_IOS = 68;
/** Mobile row spacing from the Figma layout. */
export const MOBILE_ROW_LABEL_TO_TOGGLE_GAP = 8;
/** Best-guess until design confirms badge↔pill spacing (matches label→toggle). */
export const MOBILE_ROW_BADGE_TO_TOGGLE_GAP = 8;
export const MOBILE_ROW_TOGGLE_TO_CHEVRON_GAP = 12;
export const ROW_PADDING_LEFT = 16;
export const CHECKBOX_WIDTH = 32;
export const CHEVRON_SIZE = 24;
export const LEVEL_INDENT_BASE = 24;
export const LEVEL_INDENT_INCREMENT = 32;
export const CLICK_DELAY = 200;
/**
 * Two plain clicks on the same row within this window are a double-click.
 * Selection paints on the first click, which can re-render the virtualized row
 * and replace its DOM node before the browser emits dblclick. The row detects
 * the second click itself. Kept shorter than the OS double-click interval so that
 * clicking an already selected row again to deselect it is not mistaken for a
 * double-click.
 */
export const DOUBLE_CLICK_MS = 300;
/**
 * A plain click on an already selected row (deselect a sole row, or narrow a
 * multi-selection to it) waits this long, so a quick double-click can cancel it and
 * expand the row with the selection intact. Independent of CLICK_DELAY, which only
 * the legacy row uses.
 */
export const SELECTED_ROW_CLICK_DELAY_MS = 200;
/**
 * Trailing auto-generated index suffix that search-db appends to disambiguate
 * sibling objects, e.g. the " (69)" in "Upholstery Arms (69)". Capture group 1
 * is the clean base name. Parentheses are required so legitimate trailing
 * numbers (e.g. "Level 1", "Grid 100") are preserved.
 */
export const INDEX_SUFFIX_PATTERN = /^(.+?)\s+\(\d+\)$/;
